export interface BranchStorageValue {
  branch: string;
  timestamp: number;
}

export const ACCESS_ORIGINS = [
  'IMB',
  'GUS',
  'PAL',
  'TAM',
  'AJU',
  'CAU',
  'ALH',
  'JPA',
  'CAB',
  'OBC',
  'ROY',
  'PNG',
  'LAU',
  'MDC',
  'OSAL',
  'CA2',
  'AME2',
  'BAR',
  'ROY2',
  'SITE',
] as const;

export type AccessOrigin = (typeof ACCESS_ORIGINS)[number];
